import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

import { cn } from "../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-colors [&_svg]:size-3 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary: "border-transparent bg-grayA-3 text-gray-11",
        secondary: "border-grayA-5 bg-transparent text-gray-11 font-normal",
        success: "border-transparent bg-successA-3 text-success-11",
        warning: "border-transparent bg-warningA-3 text-warning-11",
        blocked: "border-transparent bg-orangeA-3 text-orange-11",
        error: "border-transparent bg-errorA-3 text-error-11",
        count:
          "border-transparent bg-grayA-4 text-gray-12 h-4 min-w-4 px-1 text-2xs font-semibold tabular-nums justify-center",
      },
      size: {
        DEFAULT: "",
        sm: "px-1.5 py-px",
      },
      font: {
        mono: "font-mono",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  ref?: React.Ref<HTMLSpanElement>;
}

function Badge({ className, variant, size, font, children, ref, ...props }: BadgeProps) {
  return (
    <span ref={ref} className={cn(badgeVariants({ variant, size, font }), className)} {...props}>
      {children}
    </span>
  );
}

export { Badge, badgeVariants };
